module.exports = __webpack_public_path__ + "images/profileIcon-93749eb6fbd787199aa2f11742708dcf.svg";